import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import MasterMaintenanceMenuList from '../../components/list/MasterMaintenanceMenuList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00011',
  emits: ["closeDrawer"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
// 初期表示時にサイドバーを閉じる
emit('closeDrawer');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("span", null, "マスタメンテナンス", -1)
      ])),
      _: 1
    }),
    _createVNode(MasterMaintenanceMenuList, {
      mode: "tile",
      style: {"width":"80%","margin":"0 auto"}
    })
  ]))
}
}

})